const DateFormatting = {
  locale: {
    en: {
      month_names: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      month_names_short: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },
  getMonthName(date, lang) {
    lang = lang && lang in this.locale ? lang : 'en';
    return this.locale[lang].month_names[date.getMonth()];
  },
  getMonthNameShort(date, lang) {
    lang = lang && lang in this.locale ? lang : 'en';
    return this.locale[lang].month_names_short[date.getMonth()];
  }
};

export { DateFormatting };
